import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
import setYear from 'date-fns/set_year'
import addMonths from 'date-fns/add_months';
import subDays from 'date-fns/sub_days';
import subMonths from 'date-fns/sub_months';
import startOfWeek from 'date-fns/start_of_week';
import endOfWeek from 'date-fns/end_of_week';
import lastDayOfMonth from 'date-fns/last_day_of_month';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import differenceInCalendarMonths from 'date-fns/difference_in_calendar_months'
import differenceInCalendarYears from 'date-fns/difference_in_calendar_years'
import endOfMonth from "date-fns/end_of_month";
import {globalfunc} from '../globalfunc.js'
import { addDays } from 'date-fns';
export default {
    namespaced: true,
    state: {
        membersall:[],
        membersByKey: [],
        teamByKey: [],
        team_id:'',
        // peoplerisk:[],
        // peopleriskall:[],
        starperform:[],
        starperformall:[],
        talentTypeOption: [],
        talentTypeOptionMaster:[
            'Activated',
            'Contributor',
            'Core Player',
            'Crowd Favorite',
            'Developing',
            'Hidden Talent',
            'High Contributor',
            'High Performer',
            'High Potential',
            'Marginalized',
            'Rising Star',
            'Solid Performer',
            'Superstar',
            'Supported',
            'Underutilized',
            'Up-and-coming'
        ],
        networkTypeOptionMaster:[
            'Low Network',
            'Medium Network',
            'High Network',
            'Super Network',
            'Medium Inner',
            'High Inner',
            'Super Inner',
            'Medium Outer',
            'High Outer',
            'Super Outer',
        ],
        powerChartData:[],
        powerChartDataDefault:[
            {
                key: "ps_empathy",
                label: "Empathy",
                point: 0,
                point_total: 0,
                icon: "ic_empathy",
            },
            {
                key: "ps_self_awareness",
                label: "Self-awareness",
                point: 0,
                point_total: 0,
                icon: "ic_selfawareness",
            },
            {
                key: "ps_critical_thinking",
                label: "Critical Thinking",
                point: 0,
                point_total: 0,
                icon: "ic_criticalthinking",
            },
            {
                key: "ps_leadership",
                label: "Leadership",
                point: 0,
                point_total: 0,
                icon: "ic_leadership",
            },
            {
                key: "ps_initiative_making",
                label: "Initiative-making",
                point: 0,
                point_total: 0,
                icon: "ic_initiative",
            },
            {
                key: "ps_optimism",
                label: "Optimism",
                point: 0,
                point_total: 0,
                icon: "ic_optimism",
            },
        ],
        inputSearch: '',
        users:[],
        type:'all',
        page:1,
        size_page:50,
        loadpage:false,
        sortfield:'risk_level',
        sortorder:'desc',
        modalMemberData: [],
        riskData:[],
        months:format(addMonths(new Date(),1),"YYYY-MM"),
        risk:{},
        starPerformer:{},
        holiday:{},
        date:format(new Date(),"YYYY-MM-DD"),
        loadingLoadMoreData:false,
        powerData:[],
        allDataRisk: [],
        allDataStar: [],
        allDataImpact: [],
        masterDate: [],
        masterDateImpact: [],
        teamHeight: '',
        RiskAndStarChart: {},
        labelDate: ['','','','','','','',''],
        talentChartData: {},
        networkChartData: {},
        excelsAtDataChart: [],
        excelsAtDataChartAll: [],
        viewListExcelsData: [],
        viewListExcelsDataAll: [],
        allusersPeerfeedback: [],
        loadingDataChartFirstTime: true,
        loadingDataChart: true,
        allDataImpactTooltip: [],
        organization1level: {},
        riskCategory:[],
        alignement:{},
        recognition:{},
      medals:[]
    },
    mutations: {
        // setPeopleRiskAll(state:any, result:any) {
        //     state.peopleriskall = result
        // },
        // setPeopleRisk(state:any, result:any) {
        //     state.peoplerisk = result
        // },
        setPeoplePerformAll(state:any, result:any) {
            state.starperformall = result
        },
        setPeoplePerform(state:any, result:any) {
            state.starperform = result
        },
        setinputSearch(state:any,value:any) {
            state.inputSearch = value.keyword
            state.type = value.userstatus
        },
        setTeamId(state:any,value:any) {
            state.team_id = value.keyword
        },
        setUsers(state:any,value:any) {
            state.users = value
        },
        setMemberall(state:any, result:any) {
            state.membersall = result
        },
        setLoadpage(state:any,result:any) {
            state.loadpage = result
        },
        setPage(state:any,result:any) {
            state.page = result
        },
        setType(state:any,result:any) {
            state.type = result
        },
        setTalentTypeOption(state:any,result:any) {
            state.talentTypeOption = result
        },
        setModalMemberData(state:any, result:any) {
            state.modalMemberData = result
        },
        setMemberKey(state:any, result:any) {
            state.membersByKey = result
        },
        setTeamKey(state:any, result:any) {
            state.teamByKey = result
        },
        setRisk(state:any, result:any) {
            state.risk = result
        },
        setStarPerformer(state:any, result:any) {
            state.starPerformer = result
        },
        setHoliday(state:any, result:any) {
            state.holiday = result
        },
        setLoadingLoadMoreData(state:any, result:any) {
            state.loadingLoadMoreData = result
        },
        setPowerData(state:any, result:any) {
            state.powerData = result
        },
        setAllDataRisk(state:any, result:any) {
            state.allDataRisk = result
        },
        setAllDataStar(state:any, result:any) {
            state.allDataStar = result
        },
        setImpactTooltip(state:any, result:any) {
            state.allDataImpactTooltip = result
        },
        setAllDataImpact(state:any, result:any) {
            state.allDataImpact = result
        },
        setMasterDate(state:any, result:any) {
            state.masterDate = result
        },
        setMasterDateImpact(state:any, result:any) {
            state.masterDateImpact = result
        },
        setTeamHeight(state: any, value: any) {
            state.teamHeight = value
        },
        setRiskAndStarChart(state: any, value: any) {
            state.RiskAndStarChart = value
        },
        setLabelDate(state: any, value: any) {
            state.labelDate = value
        },
        setTalentChartData(state: any, value: any) {
            state.talentChartData = value
        },
        setNetworkChartData(state: any, value: any) {
            state.networkChartData = value
        },
        setPowerChartData(state: any, value: any) {
            state.powerChartData = value
        },
        setExcelsAtDataChart(state: any, value: any) {
            state.excelsAtDataChart = value
        },
        setExcelsAtDataChartAll(state: any, value: any) {
            state.excelsAtDataChartAll = value
        },
        setViewListExcelsData(state: any, value: any) {
            state.viewListExcelsData = value
        },
        setViewListExcelsDataAll(state: any, value: any) {
            state.viewListExcelsDataAll = value
        },
        setLoadingDataChartFirstTime(state: any, value: any) {
            state.loadingDataChartFirstTime = value
        },
        setLoadingDataChart(state: any, value: any) {
            state.loadingDataChart = value
        },
        setAllusersPeerfeedback(state: any, value: any) {
            state.allusersPeerfeedback = value
        },
        setOrganization1level(state: any, value: any) {
            state.organization1level = value
        },
        setriskCategory(state:any, result:any) {
            state.riskCategory = result
        },
        setAlignement(state:any, result:any) {
            state.alignement = result
        },
        setRecognition(state:any, result:any) {
            state.recognition = result
        },
        setTruly(state:any, result:any) {
            state.truly = result
        },
        setMedals(state:any, result:any) {
            state.medals = result
        }
    },
    
    actions: {
        async getStarAndRiskPerform({commit,dispatch,state,rootState}:any, user:any){
            if(Object.keys(rootState.main.allUser).length>0){
                await dispatch('main/getuser',true,{root:true})
            }
            let dateNow = new Date()
            let thisYear = parseInt(format(dateNow, 'YYYY'))
            let talentChartData = {}
            let networkChartData = {}
            let powerChartData = state.powerChartDataDefault
            const allUser = (await firebase.database().ref('users').orderByChild("company").equalTo(user.company).once('value')).val()
            const boss=_.groupBy(allUser, 'boss')
            let sumPowerChart:Array<any> = [];
            commit('setPowerChartData',[])
            const organization1level = {}
            if(user.user_type == 'leadership'){
                if(user.email){
                    const emailKey = user.email.replace(/\./g, '||')
                    var userData = allUser[emailKey]
                }
                if(userData){
                    await firebase.firestore().collection('organization1level').where("company", "==", userData.company).where("team_id","==",userData.team).get()
                    .then((querySnapshot)=> {
                        if(querySnapshot.empty){
                            organization1level[userData.team] = true
                        }else{
                            querySnapshot.forEach((doc)=> {
                                _.forEach(doc.data().parent, function(_,key) {
                                    organization1level[key] = true
                                });
                            });
                        }
                        commit('setOrganization1level', organization1level)
                    });
                }
            }
            // commit('setLoadingDataChart',true)
            const team: { [key: string]: any; } = {};
            if(rootState.team.teamsall.length > 0){
                _.forEach(rootState.team.teamsall, (value)=> {
                    team[value.key] = value
                });
            }else{
                const team2 = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
                _.forEach(team2, (value,key)=> {
                    team[key] = value
                });
            }

            if(state.membersall.length == 0){
                const company = (await firebase.database().ref(`/company/${user.company}`).once('value')).val()
                const allteam = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
                const allusersPeerfeedback:Array<any> = [];
                const excelsAtEachType:Array<any> = [];
                const excelsAtDataChart:Array<any> = [];
                const viewListExcelsData:Array<any> = [];
                await firebase.firestore().collection('users_achievements').where("company", "==", user.company).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const _data:any = doc.data()
                        let emailKey = _data.email.replace(/\./g, "||");
                        if(allUser&&allUser[emailKey] && _data.peerfeedback){
                            allusersPeerfeedback[_data.email] = _data.peerfeedback
                            for(const peerfeedback in _data.peerfeedback){
                                if(excelsAtEachType[peerfeedback] == undefined){
                                    excelsAtEachType[peerfeedback] = new Array()
                                }
                                if(user.user_type == 'leadership'){
                                    if(organization1level[allUser[emailKey].team]){
                                        excelsAtEachType[peerfeedback].push({email: _data.email, peerfeedback: _data.peerfeedback[peerfeedback]})
                                    }
                                }else{
                                    excelsAtEachType[peerfeedback].push({email: _data.email, peerfeedback: _data.peerfeedback[peerfeedback]})
                                }
                            }
                        }
                    });
                    for(const x in excelsAtEachType){
                        excelsAtEachType[x] = _.orderBy(excelsAtEachType[x],['peerfeedback', 'email'], ['desc', 'asc'])
                    }
                });
                const users:Array<any> = [];
                const memberKey:Array<any> = [];
                for(const arrData in allUser){
              
                    const u = allUser[arrData]
                        u.key = arrData
                        if(u&&!u.placeholder){
                            if(user.user_type == 'leadership'){
                                if(organization1level[u.team]){
                                    users.push(u)
                                }
                            }else{
                                users.push(u)
                            }
                        }
                        
                }
                // await firebase.database().ref('users').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
                //     snapshot.forEach((arrData): any => {
                //         const u = arrData.val()
                //         u.key = arrData.key
                //         if(user.user_type == 'leadership'){
                //             if(organization1level[u.team]){
                //                 users.push(u)
                //             }
                //         }else{
                //             users.push(u)
                //         }
                //     });
                    firebase.database().ref('users_not_used').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
                        snapshot.forEach((arrData): any => {
                            const u = arrData.val()
                            u.key = arrData.key
                            if(user.user_type == 'leadership'){
                                if(organization1level[u.team]){
                                    users.push(u)
                                }
                            }else{
                                users.push(u)
                            }
                        });
                    });
                    firebase.database().ref('users_employee_exit').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
                        snapshot.forEach((arrData): any => {
                            const u = arrData.val()
                            u.key = arrData.key
                            if(user.user_type == 'leadership'){
                                if(organization1level[u.team]){
                                    users.push(u)
                                }
                            }else{
                                users.push(u)
                            }
                        });
                    });
                    _.forEach(users, (value,key)=> {
                        let _data = value
                        // let talentClass: any = '';
                        // let networkClass: any = '';
                        // let trulyClass: any = '';
                        // let starClass: any = '';
                        // let engagementClass: any = ''; 
                        if(_data.profilepic_small){
                            _data.pic = _data.profilepic_small;
                          }else if (_data.profilepic_crop){
                            _data.pic = _data.profilepic_crop;
                          }else if (_data.profilepic){
                            _data.pic = _data.profilepic;
                          }else {
                            _data.pic = "";
                          }

                        if(_data.profilepic) {
                            _data.large_pic = _data.profilepic
                        }else if(_data.profilepic_crop) {
                            _data.large_pic = _data.profilepic_crop
                        }else if(_data.profilepic_small){
                            _data.large_pic = _data.profilepic_small
                        }else {
                            _data.large_pic = ""
                        }

                        if(_data.tutorial && _data.tutorial == 'Y'){
                            let dayActive = differenceInCalendarDays(dateNow, _data.updated)
                            if(dayActive > 30){
                                _data.status = 'inactive'
                                _data.to_now = format(_data.updated,'MMM D, YYYY')
                            }else{
                                _data.status = 'active'
                                _data.to_now = globalfunc.timeSince(_data.updated)
                            }
                        }else if(_data.invited){
                            _data.status = 'invited'
                            _data.to_now = globalfunc.timeSince(_data.invited)
                        }else{
                            _data.status = 'new'
                        }
                        _data.medalCount = 0
                        if(company.medals && _data.medal){
                      
                            _.forEach(_data.medal, (value,key)=> {
                                if(value.image){
                                    _data.medalCount += value.value
                                }else{
                                    _data.medalCount += value
                                }
                               
                            });
                        }
                        if(_data.joined_tooltips === undefined){
                            _data.joined_tooltips = new Array()
                        }
                        if(_data.workdate){
                            _data.joined = format(_data.workdate,'MMMM D, YYYY')
                            let arrJoined:Array<any> = [];
                            arrJoined['year'] = differenceInCalendarYears(dateNow, _data.workdate)
                            let month = differenceInCalendarMonths(dateNow, setYear(_data.workdate,thisYear))
                            if(month < 0){
                                arrJoined['month'] = month + 12
                                arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
                            }else{
                                arrJoined['month'] = month
                            }
                            let day = parseInt(format(dateNow,'DD')) - parseInt(format(_data.workdate,'DD'))
                            if(day < 0){
                                arrJoined['day'] = day + parseInt(format(lastDayOfMonth(addMonths(dateNow, -1)),'DD'));
                                if(arrJoined['month'] > 0){
                                arrJoined['month'] = arrJoined['month'] - 1
                                }else{
                                arrJoined['month'] = 12
                                arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
                                }
                            }else{
                                arrJoined['day'] = day
                            }
                            _data.joined_tooltips.push(arrJoined)
                        }
                        if(allusersPeerfeedback[_data.email]){
                            let sort_peerfeedback = Object.keys(allusersPeerfeedback[_data.email]).sort(function(a,b){return allusersPeerfeedback[_data.email][b] - allusersPeerfeedback[_data.email][a]})
                            _data['peerfeedback'] = new Object()
                            _data['excel_type'] = new Array()
                            _.forEach(sort_peerfeedback, (value,key)=> {
                                let excel:Array<any> = [];
                                if(_data['excel_type'].length < 3){
                                    excel['name'] = value
                                    excel['total'] = allusersPeerfeedback[_data.email][value]
                                    _data['excel_type'].push(excel)
                                }
                                _data['peerfeedback'][value] = allusersPeerfeedback[_data.email][value]
                            });
                        }
                        // if(_data.engagement_group == 'Inactive'){
                        //     engagementClass='a'
                        // }else if(_data.engagement_group == 'Somewhat Engaged'){
                        //     engagementClass = 'b'
                        // }else if(_data.engagement_group == 'Moderately Engaged'){
                        //     engagementClass = 'c'
                        // }else if(_data.engagement_group == 'Highly Engaged'){
                        //     engagementClass = 'd'
                        // }else{
                        //     engagementClass = 'a'
                        // }

                        // if(_data.talent=='Marginalized'){
                        //     talentClass='a'
                        // }else if(_data.talent=='Up-and-coming'||
                        // _data.talent=='Contributor'||
                        // _data.talent=='Supported'||
                        // _data.talent=='Rising Star'||
                        // _data.talent=='Crowd Favorite'||
                        // _data.talent=='Underutilized'||
                        // _data.talent=='High Contributor'||
                        // _data.talent=='Developing'||
                        // _data.talent=='Hidden Talent'){
                        //     talentClass='b'
                        // }
                        // else if(_data.talent=='Activated'||
                        // _data.talent=='Core Player'||
                        // _data.talent=='High Potential'){
                        //     talentClass='c'
                        // }
                        // else if(_data.talent=='High Performer'||
                        // _data.talent=='Solid Performer'||
                        // _data.talent=='Superstar'){
                        //     talentClass='d'
                        // }
                        // if(_data.network_type=='Low Network'||
                        // _data.network_type=='Medium Outer'||
                        // _data.network_type=='Medium Inner'){
                        //     networkClass='a'
                        // }else if(_data.network_type=='Medium Network'||
                        // _data.network_type=='High Outer'||
                        // _data.network_type=='High Inner'){
                        //     networkClass='b'
                        // }else if(_data.network_type=='High Network'||
                        // _data.network_type=='Super Outer'||
                        // _data.network_type=='Super Inner'){
                        //     networkClass='c'
                        // }else if(_data.network_type=='Super Network'){
                        //     networkClass='d'
                        // }
                        // if(_data.truly>=4){
                        //     trulyClass='d'
                        // }else if(_data.truly>=2&&_data.truly<=3){
                        //     trulyClass='c'
                        // }else if(_data.truly==1){
                        //     trulyClass='b'
                        // }else if(_data.truly<=0){
                        //     trulyClass='a'
                        // }
            
                        // if(_data.star>=6){
                        //     starClass='d'
                        // }else if(_data.star>=4&&_data.star<=5){
                        //     starClass='c'
                        // }else if(_data.star>=1&&_data.star<=3){
                        //     starClass='b'
                        // }else if(_data.star<=0){
                        //     starClass='a'
                        // }
                        // _data.engagementClass = engagementClass
                        // _data.talentClass = talentClass
                        // _data.networkClass = networkClass
                        // _data.trulyClass = trulyClass
                        // _data.starClass = starClass

                        if(_data.talent){
                            if(talentChartData[_data.talent] == undefined){
                                talentChartData[_data.talent] = 1
                            }else{
                                talentChartData[_data.talent] += 1
                            }
                        }
                        if(_data.network_type){
                            if(networkChartData[_data.network_type] == undefined){
                                networkChartData[_data.network_type] = 1
                            }else{
                                networkChartData[_data.network_type] += 1
                            }
                        }
                        if(_data.power_tag){
                            for(const x in _data.power_tag){
                                if(sumPowerChart[x] == undefined){
                                    sumPowerChart[x] = new Array()
                                    sumPowerChart[x]['point'] = 0
                                    sumPowerChart[x]['point_total'] = 0
                                }
                                sumPowerChart[x]['point'] += _data.power_tag[x]['point']
                                sumPowerChart[x]['point_total'] += _data.power_tag[x]['point_total']
                            }
                        }
                        if(_data.healthbar){
                            _data.healthbar = _data.healthbar * 1
                        }else{
                            _data.healthbar = 0
                        }
                        if(_data.impact_rating){
                            _data.impact_rating = globalfunc.round(_data.impact_rating,1)
                        }else{
                            _data.impact_rating = 0
                        }
                        if(_data.impact_rating_lastweek){
                            _data.impact_rating_lastweek = globalfunc.round(_data.impact_rating_lastweek,1)
                        }else{
                            _data.impact_rating_lastweek = 0
                        }
                        if(_data.impact_rating > _data.impact_rating_lastweek){
                            _data.impact_compare = globalfunc.round((_data.impact_rating - _data.impact_rating_lastweek),1)
                        }else if(_data.impact_rating_lastweek > _data.impact_rating){
                            _data.impact_compare = globalfunc.round((_data.impact_rating_lastweek - _data.impact_rating),1)
                        }else if(_data.impact_rating_lastweek == _data.impact_rating){
                            _data.impact_compare = 0
                        }
                        _data.impact_rating = parseFloat(_data.impact_rating.toFixed(1))
                        _data.impact_rating_lastweek = parseFloat(_data.impact_rating_lastweek.toFixed(1))
                        _data.impact_compare = parseFloat(_data.impact_compare.toFixed(1))
                        memberKey[_data.key] = _data
                    });
                    let _users:Array<any> = [];
                    _users = _.sortBy(users, [function(o:any) { return o.workdate; }])
                    let orderJoin = 1
                    _.forEach(_users, (item,key)=> {
                        if(item.workdate){
                            _users[key].order_join = orderJoin
                            orderJoin++
                        }
                    });
                    _.forEach(powerChartData, (item, index) => {
                        if(sumPowerChart[item.key]){
                            powerChartData[index]['point'] = sumPowerChart[item.key]['point']
                            powerChartData[index]['point_total'] = sumPowerChart[item.key]['point_total']
                        }
                    });
                    let sort_excelsAtDataChart = Object.keys(excelsAtEachType).sort(function(a,b){return excelsAtEachType[b].length - excelsAtEachType[a].length})
                    let allMemberCount = Object.keys(memberKey).length
                    _.forEach(sort_excelsAtDataChart, (value,key)=> {
                        let datachart = {}
                        let viewList = {}
                        datachart['label'] = value
                        datachart['userCount'] = excelsAtEachType[value].length
                        datachart['topUser'] = new Array()
                        _.forEach(excelsAtEachType[value], (value,key)=> {
                            let obj = {}
                            let emailKey = value.email.replace(/\./g, "||");
                            let firstname = memberKey[emailKey].firstname ? memberKey[emailKey].firstname : ''
                            let lastname = memberKey[emailKey].lastname ? memberKey[emailKey].lastname : ''
                            let fullname = firstname +' '+ lastname
                            obj['fullname'] = fullname
                            obj['userId'] = emailKey
                            obj['imageProfile'] = memberKey[emailKey].pic
                            obj['excelsCount'] = value.peerfeedback
                            datachart['topUser'].push(obj)
                        });
                        if(excelsAtDataChart.length == 0){
                            datachart['expand'] = true
                            
                        }else{
                            datachart['expand'] = false
                        }
                        datachart['percentage'] = (datachart['userCount'] * 100) / allMemberCount
                        
                        viewList['label'] = value
                        viewList['userCount'] = excelsAtEachType[value].length
                        viewList['userList'] = new Array()
                        _.forEach(excelsAtEachType[value], (value,key)=> {
                            let obj = {}
                            let emailKey = value.email.replace(/\./g, "||");
                            let firstname = memberKey[emailKey].firstname ? memberKey[emailKey].firstname : ''
                            let lastname = memberKey[emailKey].lastname ? memberKey[emailKey].lastname : ''
                            let fullname = firstname +' '+ lastname
                            obj['fullname'] = fullname
                            obj['userId'] = emailKey
                            obj['imageProfile'] = memberKey[emailKey].pic
                            obj['excelsCount'] = value.peerfeedback
                            obj['team_name'] = (memberKey[emailKey].team && allteam[memberKey[emailKey].team]) ? allteam[memberKey[emailKey].team].name : ''
                            viewList['userList'].push(obj)
                        });
                        excelsAtDataChart.push(datachart)
                        viewListExcelsData[value] = viewList
                    });
                    commit('setMemberKey', memberKey)
                    commit('setTeamKey',allteam)
                    commit('setMemberall', _users)
                    commit('setTalentChartData', talentChartData)
                    commit('setNetworkChartData',networkChartData)
                    commit('setPowerChartData',powerChartData)
                    commit('setExcelsAtDataChart',excelsAtDataChart)
                    commit('setExcelsAtDataChartAll',excelsAtDataChart)
                    commit('setViewListExcelsData', viewListExcelsData)
                    commit('setViewListExcelsDataAll', viewListExcelsData)
                    commit('setAllusersPeerfeedback',allusersPeerfeedback)
                    // commit('setLoadingDataChart',false)
                //});
            }
            const TalentData:Array<any> = [];
            const NetworkData:Array<any> = [];
            //Risk Area 
            const riskarea: { [key: string]: any; } = {}
            firebase.firestore().collection('report_weekly_risk_area').where("company", "==", user.company).get()
            .then((querySnapshot)=> {
                querySnapshot.forEach(async (doc)=> {
                    if(riskarea[doc.data().email]){
                        riskarea[doc.data().email] += ", " + doc.data().category
                    }else{
                        riskarea[doc.data().email] = doc.data().category
                    }
                });
            });
            //Risk
            const riskusers: { [key: string]: any; } = {}
            /* Comment for find date range 
             const dateNow = new Date()
             const sat_of_lastweek = format(startOfWeek(dateNow,{weekStartsOn:-1}), 'YYYY-MM-DD');
            */
            await firebase.firestore().collection('report_weekly_risk').where("company", "==", user.company).get()
            .then((querySnapshot)=> {
                const users:Array<any> = [];
                querySnapshot.forEach(async (doc)=> {
                    riskusers[doc.data().email] = doc.data()
                    let key = "";
                    key = doc.data().email.replace(/[+]/g, '\\$&')
                    var re = new RegExp(key, 'gi')
                    _.filter(state.membersall, (item): any => {
                        if (item.email.match(re)){
                            riskusers[doc.data().email].profilepic_crop = (item.profilepic_crop)?item.profilepic_crop:item.profilepic
                            riskusers[doc.data().email].firstname = item.firstname
                            riskusers[doc.data().email].lastname = item.lastname
                            riskusers[doc.data().email].team_name = (team[doc.data().team])?team[doc.data().team].name:''
                            riskusers[doc.data().email].problem_area = (riskarea[doc.data().email])?riskarea[doc.data().email]:'Happiness'
                            riskusers[doc.data().email].talent = item.talent
                            riskusers[doc.data().email].performer = item.star
                            if(item.talent){
                                if(TalentData[item.talent] === undefined){
                                    TalentData[item.talent] = new Array()
                                }
                                TalentData[item.talent][item.email] = item.email
                            }
                            if(item.network_type){
                                if(NetworkData[item.network_type] === undefined){
                                    NetworkData[item.network_type] = new Array()
                                }
                                NetworkData[item.network_type][item.email] = item.email
                            }
                        }
                        });
                    
                    users.push(riskusers[doc.data().email])
                });
                // commit('setPeopleRiskAll', users)
                // commit('setPeopleRisk', users)
            });
            if(state.users.length>0){
                const users:Array<any> = [];
                const usersFirstTime:Array<any> = [];
                _.forEach(state.users, (u) => {
                    // if(u.star != undefined && u.star > 0){
                        if(u.team && team[u.team]) u.team_name = team[u.team]["name"]
                        else u.team_name = '';
                        u.risk_level = (riskusers[u.email])?riskusers[u.email].risk_level.toString():''
                        u.no_risk = (riskusers[u.email])?'':999
                        u.problem_area = (riskusers[u.email])?riskusers[u.email].problem_area:'Happiness'
                        u.risk_due=(riskusers[u.email])?riskusers[u.email].risk_due:''
                        u.star = (u.star)?u.star:0
                        if(u.talent){
                            if(TalentData[u.talent] === undefined){
                                TalentData[u.talent] = new Array()
                            }
                            TalentData[u.talent][u.email] = u.email
                        }
                        if(u.network_type){
                            if(NetworkData[u.network_type] === undefined){
                                NetworkData[u.network_type] = new Array()
                            }
                            NetworkData[u.network_type][u.email] = u.email
                        }
                        users.push(u)
                        if(user.user_type == 'leadership'){
                            if(organization1level[u.team]){
                                usersFirstTime.push(u)
                            }
                        }
 
                    // }
                });
                // var _users = users
                commit('setLoadpage',true)
                if(user.user_type == 'leadership'){
                    for(const user in usersFirstTime){
                        
                        usersFirstTime[user].house_level =await dispatch('getHouseLavel',{user:usersFirstTime[user],boss:boss})
                    }
                    var _usersFirstTime = _.orderBy(usersFirstTime, [function(o:any) { return o.risk_level; },function(o:any) { return o.impact_rating; }], [state.sortorder,'desc'])
                    commit('setPeoplePerform', _.orderBy(_usersFirstTime.slice(0, state.size_page), [function(o:any) { return o.risk_level; },function(o:any) { return o.impact_rating; }], [state.sortorder,'desc']))
                    commit('setPeoplePerformAll', _.orderBy(_usersFirstTime, [function(o:any) { return o.risk_level; }], [state.sortorder]))
                }else{
                    for(const user in users){
                        
                        users[user].house_level =await dispatch('getHouseLavel',{user:users[user],boss:boss})
                    }
                    var _users = _.orderBy(users, [function(o:any) { return o.risk_level; },function(o:any) { return o.impact_rating; }], [state.sortorder,'desc'])
                    commit('setPeoplePerform', _.orderBy(_users.slice(0, state.size_page), [function(o:any) { return o.risk_level; },function(o:any) { return o.impact_rating; }], [state.sortorder,'desc']))
                    commit('setPeoplePerformAll', _.orderBy(_users, [function(o:any) { return o.risk_level; }], [state.sortorder]))
                }
                // commit('setLoadingDataChart',false)
                if(state.inputSearch){
                dispatch('searchMembers',state.inputSearch)
                }
            }else{
                const users:Array<any> = [];
                const usersFirstTime:Array<any> = [];
                const _users:Array<any> = [];
                _.forEach(state.membersall, (value,key)=> {
                    // if(value.exitdated == undefined){
                        const u = value
                        u.key = value.email.replace(/\./g, '||')
                        // if(u.star != undefined && u.star > 0){
                            if(u.team && team[u.team]) u.team_name = team[u.team]["name"]
                            else u.team_name = '';
                            /// FIX DATA
                            //u.talent = 'Underutilized Talent'
                            u.risk_level = (riskusers[u.email])?riskusers[u.email].risk_level.toString():''
                            u.no_risk = (riskusers[u.email])?'':999
                            u.problem_area = (riskusers[u.email])?riskusers[u.email].problem_area:'Happiness'
                            u.risk_due=(riskusers[u.email])?riskusers[u.email].risk_due:''
                            u.star = (u.star)?u.star:0
                            u.talent_value_coin = (u.talent_value&&u.talent_value.coin)?u.talent_value.coin:''
                            u.talent_value_gem = (u.talent_value&&u.talent_value.gem)?u.talent_value.gem:''
                            
                            /// END FIX DATA
                            if(u.talent){
                                if(TalentData[u.talent] === undefined){
                                    TalentData[u.talent] = new Array()
                                }
                                TalentData[u.talent][u.email] = u.email
                            }
                            if(u.network_type){
                                if(NetworkData[u.network_type] === undefined){
                                    NetworkData[u.network_type] = new Array()
                                }
                                NetworkData[u.network_type][u.email] = u.email
                            }
                            users.push(u)
                
                        // }
                        _users.push(u)
                        if(user.user_type == 'leadership'){
                            if(organization1level[u.team]){
                                usersFirstTime.push(u)
                            }
                        }
                    // } 
                });
                
                
                commit('setLoadpage',true)
                // commit('setLoadingDataChart',false)
                commit('setUsers',_.orderBy(_users, [function (o) { return o.risk_level; },'impact_rating'], [state.sortorder,'desc']))
                if(user.user_type == 'leadership'){
                    for(const user in usersFirstTime){
                        
                        usersFirstTime[user].house_level =await dispatch('getHouseLavel',{user:usersFirstTime[user],boss:boss})
                    }
                    var _usersFirstTime = _.orderBy(usersFirstTime, [function (o) { return o.risk_level; },'impact_rating'], [state.sortorder,'desc'])
                    commit('setPeoplePerform', _.orderBy(_usersFirstTime.slice(0, state.size_page), [function(o:any) { return o.risk_level; },function(o:any) { return o.impact_rating; }], [state.sortorder,'desc']))
                    commit('setPeoplePerformAll', _.orderBy(_usersFirstTime, [function(o:any) { return o.risk_level; }], [state.sortorder]))
                }else{
                    for(const user in users){
                        
                        users[user].house_level =await dispatch('getHouseLavel',{user:users[user],boss:boss})
                       // console.log('users[user].house_level', users[user].house_level)
                    }
                   
                    var _users2 = _.orderBy(users, [function (o) { return o.risk_level; },'impact_rating'], [state.sortorder,'desc'])
                    commit('setPeoplePerform', _.orderBy(_users2.slice(0, state.size_page), [function(o:any) { return o.risk_level; },function(o:any) { return o.impact_rating; }], [state.sortorder,'desc']))
                    commit('setPeoplePerformAll', _.orderBy(_users2, [function(o:any) { return o.risk_level; }], [state.sortorder]))
                }
                if(state.inputSearch){
                dispatch('searchMembers',state.inputSearch)
                }
            }
            
            const TalentOption:Array<any> = [];
            const NetworkOption:Array<any> = [];
            _.forEach(state.networkTypeOptionMaster, (k_networkType)=> {
                const NetworkArr:Array<any> = [];
                _.forOwn(NetworkData[k_networkType], function(user) {
                    NetworkArr.push(user);
                });
                NetworkOption.push({type: k_networkType, count: NetworkArr.length})
            });
            _.forEach(state.talentTypeOptionMaster, (k_talentType)=> {
                const TalentArr:Array<any> = [];
                _.forOwn(TalentData[k_talentType], function(user) {
                    TalentArr.push(user);
                });
                TalentOption.push({type: k_talentType, count: TalentArr.length})
            });
            let optionAllType = _.concat(_.orderBy(NetworkOption, ['type'], ['asc']), _.orderBy(TalentOption, ['type'], ['asc']))
            // commit('setTalentTypeOption', _.sortBy(TalentOption, [function(o:any) { return o.talent; }]))
            
            commit('setTalentTypeOption', optionAllType)
        },
        getHouseLavel({commit,state}:any,data:any){
            const value=data.user
            const boss=data.boss
            const rank_level =(value.engagement && value.engagement.past30days && value.engagement.past30days.star)?value.engagement.past30days.star:0
            
            let houseLavel=''
            if(value.house){
               
                if(boss[value.email]){
                    if(value.house === '-LWPrZbcyHAVHIFUsWLd'){//Corvus
                        if(rank_level === 1){
                            houseLavel = 'icb-co-Inte-m'
                        }else if(rank_level === 2){
                            houseLavel = 'icb-co-Adv-m'
                        }else if(rank_level === 3){
                            houseLavel ='icb-co-elite-m'
                        }else{
                            houseLavel = 'icb-co-novice-m'
                        }
                    }else if(value.house === '-LWPrOElCYViBd6j6qP-'){ //Leonos
                        if(rank_level === 1){
                            houseLavel ='icb-leo-Inte-m'
                        }else if(rank_level === 2){
                            houseLavel = 'icb-leo-Adv-m'
                        }else if(rank_level === 3){
                            houseLavel = 'icb-leo-elite-m'
                        }else{
                            houseLavel = 'icb-leo-novice-m'
                        }
                    }else if(value.house === '-LWOr-XsbZM2digYl1QL'){ //Delphinus
                    if(rank_level === 1){
                        houseLavel = 'icb-del-Inte-m'
                    }else if(rank_level === 2){
                        houseLavel = 'icb-del-Adv-m'
                    }else if(rank_level === 3){ 
                        houseLavel ='icb-del-elite-m'
                    }else{
                        houseLavel = 'icb-del-novice-m'
                }
            }
                }else{
                    if(value.house === '-LWPrZbcyHAVHIFUsWLd'){
                        if(rank_level === 1){
                            houseLavel = 'icb-co-Inte-e'
                        }else if(rank_level === 2){
                            houseLavel = 'icb-co-Adv-e'
                        }else if(rank_level === 3){
                            houseLavel = 'icb-co-elite-e'
                        }else{
                            houseLavel = 'icb-co-novice-e'
                        }
                    }else if(value.house === '-LWPrOElCYViBd6j6qP-'){
                        if(rank_level === 1){
                            houseLavel = 'icb-leo-Inte-e'
                        }else if(rank_level === 2){
                            houseLavel = 'icb-leo-Adv-e'
                        }else if(rank_level === 3){
                            houseLavel = 'icb-leo-elite-e'
                        }else{
                            houseLavel = 'icb-leo-novice-e'
                        }
                    }else if(value.house === '-LWOr-XsbZM2digYl1QL'){
                        if(rank_level === 1){
                            houseLavel = 'icb-del-Inte-e'
                        }else if(rank_level === 2){
                            houseLavel = 'icb-del-Adv-e'
                        }else if(rank_level === 3){
                            houseLavel = 'icb-del-elite-e'
                        }else{
                            houseLavel = 'icb-del-novice-e'
                        }
                    }
                }

            }
            else{
                if(boss[value.email]){
                    houseLavel = 'icb-empty-m'

                    if(rank_level === 1){
                        houseLavel = 'icb-empty-Inte-m'
                    }else if(rank_level === 2){
                        houseLavel = 'icb-empty-Adv-m'
                    }else if(rank_level === 3){
                        houseLavel = 'icb-empty-elite-m'
                    }

                }else{
                    houseLavel = 'icb-empty-e'

                    if(rank_level === 1){
                        houseLavel = 'icb-empty-Inte-e'
                    }else if(rank_level === 2){
                        houseLavel = 'icb-empty-Adv-e'
                    }else if(rank_level === 3){
                        houseLavel ='icb-empty-elite-e'
                    }

                }

            }
            
            return houseLavel
        },
        nextMember({commit,state}:any,value:any){
            var size = state.size_page
            var start_row = state.page * size
            var end_row = (state.page * size)+size
            let orderfix = ''
            let fieldfix = ''
            const member: Array<any> = [];
            member.push(state.starperformall)
            if(state.type == 'highest_risk'){
                state.sortorder = 'desc'
                state.sortfield = 'risk_level'
            }else if(state.type == 'lowest_risk'){
                state.sortorder = 'asc'
                state.sortfield = 'risk_level'
                orderfix = 'asc'
                fieldfix = 'no_risk'
                
            }else if(state.type == 'highest_star'){
                state.sortorder = 'desc'
                state.sortfield = 'star'
            }else if(state.type == 'lowest_star'){
                state.sortorder = 'asc'
                state.sortfield = 'star'
            }
            var _users = _.orderBy(member[0], [fieldfix,state.sortfield,'impact_rating'], [orderfix,state.sortorder,'desc']);
            start_row = 0
            commit('setPage',state.page+1)
            commit('setPeoplePerform', _users.slice(start_row,end_row))
        },
        async reponseSearchAll({commit,state,rootState}:any, param:any){
            commit('setPage',1)
            const data:Array<any> = []
            // let response1 = state.peopleriskall
            let response2 = state.starperformall
            //Start to filter by Input//
            if(state.inputSearch.length > 2){
                var re = new RegExp(state.inputSearch, 'gi')
                // response1 = _.filter(response1, (item):any => {
                //     if (item.team_name.match(re)){
                //         return true
                //     }else if(item.firstname.match(re)){
                //         return true
                //     }else if(item.lastname.match(re)){
                //         return true
                //     }
                // });
                response2 = _.filter(response2, (item):any => {
                    if (item.team_name && item.team_name.match(re)){
                        return true
                    }else if(item.firstname.match(re)){
                        return true
                    }else if(item.lastname.match(re)){
                        return true
                    }
                });
            }
            //End to filter by Input//
            //Start to filter by Team//
            if(state.team_id && state.team_id.substring(0, 1) =='-'){
                let teamsall = state.team_id
                await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).where("team_id","==",state.team_id).get()
                .then((querySnapshot)=> {
                    querySnapshot.forEach((doc)=> {
                        _.forEach(doc.data().parent, function(_,key) {
                            teamsall += '|'+key
                        });
                    });
                });
                var re = new RegExp(teamsall, 'gi')
                // response1 = _.filter(response1, (item):any => {
                //     if (item.team.match(re)){
                //         return true
                //     }
                // });
                response2 = _.filter(response2, (item):any => {
                    if (item.team.match(re)){
                        return true
                    }
                });
            }
            //End to filter by Team//

            //Start to render new Option//
            const TalentData:Array<any> = [];
            const NetworkData:Array<any> = [];
            // _.forEach(response1, (item,key)=> {
            //     if(item.talent){
            //         if(TalentData[item.talent] === undefined){
            //             TalentData[item.talent] = new Array()
            //         }
            //         TalentData[item.talent][item.email] = item.email
            //     }
            // });
            _.forEach(response2, (item,key)=> {
                if(item.talent){
                    if(TalentData[item.talent] === undefined){
                        TalentData[item.talent] = new Array()
                    }
                    TalentData[item.talent][item.email] = item.email
                }
                if(item.network_type){
                    if(NetworkData[item.network_type] === undefined){
                        NetworkData[item.network_type] = new Array()
                    }
                    NetworkData[item.network_type][item.email] = item.email
                }
            });
            const TalentOption:Array<any> = [];
            const NetworkOption:Array<any> = [];
            _.forEach(state.networkTypeOptionMaster, (k_networkType)=> {
                const NetworkArr:Array<any> = [];
                _.forOwn(NetworkData[k_networkType], function(user) {
                    NetworkArr.push(user);
                });
                NetworkOption.push({type: k_networkType, count: NetworkArr.length})
            });
            _.forEach(state.talentTypeOptionMaster, (k_talentType)=> {
                const TalentArr:Array<any> = [];
                _.forOwn(TalentData[k_talentType], function(user) {
                    TalentArr.push(user);
                });
                TalentOption.push({type: k_talentType, count: TalentArr.length})
            });
            let optionAllType = _.concat(_.orderBy(NetworkOption, ['type'], ['asc']), _.orderBy(TalentOption, ['type'], ['asc']))
            commit('setTalentTypeOption', optionAllType)
            // commit('setTalentTypeOption', _.sortBy(TalentOption, [function(o:any) { return o.talent; }]))
            //End to render new Option//

            //Start to filter by Talent && Network Type//
            if(param && param.checked.length > 0){
                let result2:Array<any> = []
                _.forEach(param.checked, (talent)=> {
                    var re = new RegExp(talent, 'gi')
                    let typeData2:Array<any> = [] 
                    typeData2 = _.filter(response2, (item):any => {
                        if(item.talent != undefined && item.talent.match(re)){
                            const chkDataExist = _.filter(result2, { email: item.email });
                            if(chkDataExist.length == 0){
                                return true
                            }
                        }else if (item.network_type != undefined && item.network_type.match(re)){
                            const chkDataExist = _.filter(result2, { email: item.email });
                            if(chkDataExist.length == 0){
                                return true
                            }
                        }
                    });
                    result2 = _.concat(result2, typeData2);
                });
                response2 = result2
            }
            //End to filter by Talent//
            let fieldfix = ''
            let orderfix = ''
            if(state.type == 'lowest_risk'){
                orderfix = 'asc'
                fieldfix = 'no_risk'
            }
            if(state.inputSearch.length > 2 || (state.team_id && state.team_id.substring(0, 1) =='-') || (param && param.checked.length > 0)){
                commit('setLoadpage',false)
                response2 = _.orderBy(response2, [fieldfix,state.sortfield,'impact_rating'], [orderfix,state.sortorder,'desc'])
            }else{
                commit('setLoadpage',true)
                var member:any = []
                member = _.orderBy(state.starperformall, [fieldfix,state.sortfield,'impact_rating'], [orderfix,state.sortorder,'desc'])
                response2 = _.orderBy(member.slice(0, state.size_page), [fieldfix,state.sortfield,'impact_rating'], [orderfix,state.sortorder,'desc'])
            }
            
            let teamsall = ''
            if(state.team_id && state.team_id.substring(0, 1) =='-'){
                teamsall = state.team_id
            }else{
                teamsall = state.teamHeight
            }
            const RiskAndStarChart = {}
            RiskAndStarChart['starperform'] = new Array()
            RiskAndStarChart['lowrisk'] = new Array()
            RiskAndStarChart['medrisk'] = new Array()
            RiskAndStarChart['highrisk'] = new Array()
            RiskAndStarChart['sumrisk'] = new Array()
            RiskAndStarChart['impact_rating'] = new Array()
            RiskAndStarChart['impact_rating_sum'] = new Array()
            RiskAndStarChart['impact_rating_count'] = new Array()
            const organization1level = {}
            await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).where("team_id","==",teamsall).get()
            .then((querySnapshot)=> {
                if(querySnapshot.empty){
                    organization1level[teamsall] = true
                }else{
                    querySnapshot.forEach((doc)=> {
                        _.forEach(doc.data().parent, function(_,key) {
                            organization1level[key] = true
                        });
                    });
                }
            });
            for(const teamId in organization1level) {
                _.forEach(state.masterDate, (dateofweek, key) => {
                    if(RiskAndStarChart['starperform'][key] == undefined){
                        RiskAndStarChart['starperform'][key] = 0
                    }
                    if(RiskAndStarChart['lowrisk'][key] == undefined){
                        RiskAndStarChart['lowrisk'][key] = 0
                    }
                    if(RiskAndStarChart['medrisk'][key] == undefined){
                        RiskAndStarChart['medrisk'][key] = 0
                    }
                    if(RiskAndStarChart['highrisk'][key] == undefined){
                        RiskAndStarChart['highrisk'][key] = 0
                    }
                    if(RiskAndStarChart['sumrisk'][key] == undefined){
                        RiskAndStarChart['sumrisk'][key] = 0
                    }
                    if(RiskAndStarChart['impact_rating'][key] == undefined){
                        RiskAndStarChart['impact_rating'][key] = 0
                    }
                    if(RiskAndStarChart['impact_rating_sum'][key] == undefined){
                        RiskAndStarChart['impact_rating_sum'][key] = 0
                    }
                    if(RiskAndStarChart['impact_rating_count'][key] == undefined){
                        RiskAndStarChart['impact_rating_count'][key] = 0
                    }
                    /* Risk Data Chart */
                    if(state.allDataRisk[dateofweek]){
                        if(state.allDataRisk[dateofweek][teamId]){
                            for(const x in state.allDataRisk[dateofweek][teamId]) {
                                if(state.inputSearch.length > 2 || (state.team_id && state.team_id.substring(0, 1) =='-') || (param && param.checked.length > 0)){
                                    if(rootState.authen.user.user_type == 'leadership' && response2.length == 0){
                                        if(state.allDataRisk[dateofweek][teamId][x].risk_level){
                                            if(state.allDataRisk[dateofweek][teamId][x].risk_level == 1){
                                                RiskAndStarChart['lowrisk'][key] += 1
                                            }else if(state.allDataRisk[dateofweek][teamId][x].risk_level == 2){
                                                RiskAndStarChart['medrisk'][key] += 1
                                            }else if(state.allDataRisk[dateofweek][teamId][x].risk_level == 3){
                                                RiskAndStarChart['highrisk'][key] += 1
                                            }
                                            RiskAndStarChart['sumrisk'][key] += 1
                                        }
                                    }else{
                                        let chkUser = _.filter(response2, { email: state.allDataRisk[dateofweek][teamId][x].email });
                                        if(chkUser.length > 0 && state.allDataRisk[dateofweek][teamId][x].risk_level){
                                            if(state.allDataRisk[dateofweek][teamId][x].risk_level == 1){
                                                RiskAndStarChart['lowrisk'][key] += 1
                                            }else if(state.allDataRisk[dateofweek][teamId][x].risk_level == 2){
                                                RiskAndStarChart['medrisk'][key] += 1
                                            }else if(state.allDataRisk[dateofweek][teamId][x].risk_level == 3){
                                                RiskAndStarChart['highrisk'][key] += 1
                                            }
                                            RiskAndStarChart['sumrisk'][key] += 1
                                        }
                                    }
                                }else{
                                    if(state.allDataRisk[dateofweek][teamId][x].risk_level){
                                        if(state.allDataRisk[dateofweek][teamId][x].risk_level == 1){
                                            RiskAndStarChart['lowrisk'][key] += 1
                                        }else if(state.allDataRisk[dateofweek][teamId][x].risk_level == 2){
                                            RiskAndStarChart['medrisk'][key] += 1
                                        }else if(state.allDataRisk[dateofweek][teamId][x].risk_level == 3){
                                            RiskAndStarChart['highrisk'][key] += 1
                                        }
                                        RiskAndStarChart['sumrisk'][key] += 1
                                    }
                                }
                            }
                        }
                    }
                    /* Star Data Chart */
                    if(state.allDataStar[dateofweek]){
                        if(state.allDataStar[dateofweek][teamId]){
                            for(const x in state.allDataStar[dateofweek][teamId]) {
                                if(state.inputSearch.length > 2 || (state.team_id && state.team_id.substring(0, 1) =='-') || (param && param.checked.length > 0)){
                                    if(rootState.authen.user.user_type == 'leadership' && response2.length == 0){
                                        if(state.allDataStar[dateofweek][teamId][x].percentile){
                                            RiskAndStarChart['starperform'][key] += 1
                                        }
                                    }else{
                                        let chkUser = _.filter(response2, { email: state.allDataStar[dateofweek][teamId][x].email });
                                        if(chkUser.length > 0 && state.allDataStar[dateofweek][teamId][x].percentile){
                                            RiskAndStarChart['starperform'][key] += 1
                                        }
                                    }
                                }else{
                                    if(state.allDataStar[dateofweek][teamId][x].percentile){
                                        RiskAndStarChart['starperform'][key] += 1
                                    }
                                }
                            }
                        }
                    }
                    /* Impact Rating Data Chart */
                    if(state.allDataImpact[dateofweek]){
                        if(state.allDataImpact[dateofweek][teamId]){
                            for(const x in state.allDataImpact[dateofweek][teamId]) {
                                if(state.inputSearch.length > 2 || (state.team_id && state.team_id.substring(0, 1) =='-') || (param && param.checked.length > 0)){
                                    if(rootState.authen.user.user_type == 'leadership' && response2.length == 0){
                                        if(state.allDataImpact[dateofweek][teamId][x].impact_rating){
                                            RiskAndStarChart['impact_rating_sum'][key] += parseFloat(state.allDataImpact[dateofweek][teamId][x].impact_rating)
                                            RiskAndStarChart['impact_rating_count'][key] += 1
                                        }
                                    }else{
                                        let chkUser = _.filter(response2, { email: state.allDataImpact[dateofweek][teamId][x].email });
                                        if(chkUser.length > 0 && state.allDataImpact[dateofweek][teamId][x].impact_rating){
                                            RiskAndStarChart['impact_rating_sum'][key] += parseFloat(state.allDataImpact[dateofweek][teamId][x].impact_rating)
                                            RiskAndStarChart['impact_rating_count'][key] += 1
                                        }
                                    }
                                }else{
                                    if(state.allDataImpact[dateofweek][teamId][x].impact_rating){
                                        RiskAndStarChart['impact_rating_sum'][key] += parseFloat(state.allDataImpact[dateofweek][teamId][x].impact_rating)
                                        RiskAndStarChart['impact_rating_count'][key] += 1
                                    }
                                }
                            }
                        }
                    }
                });
            }
            _.forEach(RiskAndStarChart['impact_rating'], (item, key) => {
                if(RiskAndStarChart['impact_rating_count'][key] > 0){
                    let total = RiskAndStarChart['impact_rating_count'][key] * 100
                    RiskAndStarChart['impact_rating'][key] = (RiskAndStarChart['impact_rating_sum'][key] * 100) / total
                }

            });
            /*Filter Chart Talent Type && Network Type && Power Skill*/
            let talentChartData = {}
            let networkChartData = {}
            let powerChartData = state.powerChartDataDefault
            let sumPowerChart:Array<any> = [];
            let allusersPeerfeedback = state.allusersPeerfeedback
            let excelsAtEachTypeSelected:Array<any> = [];
            let excelsAtDataChart:Array<any> = [];
            let viewListExcelsData:Array<any> = [];
            if(state.inputSearch.length > 2 || (state.team_id && state.team_id.substring(0, 1) =='-') || (param && param.checked.length > 0)){
                if(rootState.authen.user.user_type == 'leadership' && response2.length == 0){
                    _.forEach(state.membersall, (item, key) => {
                        if(item.talent){
                            if(talentChartData[item.talent] == undefined){
                                talentChartData[item.talent] = 1
                            }else{
                                talentChartData[item.talent] += 1
                            }
                        }
                        if(item.network_type){
                            if(networkChartData[item.network_type] == undefined){
                                networkChartData[item.network_type] = 1
                            }else{
                                networkChartData[item.network_type] += 1
                            }
                        }
                        if(item.power_tag){
                            for(const x in item.power_tag){
                                if(sumPowerChart[x] == undefined){
                                    sumPowerChart[x] = new Array()
                                    sumPowerChart[x]['point'] = 0
                                    sumPowerChart[x]['point_total'] = 0
                                }
                                sumPowerChart[x]['point'] += item.power_tag[x]['point']
                                sumPowerChart[x]['point_total'] += item.power_tag[x]['point_total']
                            }
                        }
                    });
                    excelsAtDataChart = state.excelsAtDataChartAll
                    viewListExcelsData = state.viewListExcelsDataAll
                }else{
                    _.forEach(response2, (item, key) => {
                        if(item.talent){
                            if(talentChartData[item.talent] == undefined){
                                talentChartData[item.talent] = 1
                            }else{
                                talentChartData[item.talent] += 1
                            }
                        }
                        if(item.network_type){
                            if(networkChartData[item.network_type] == undefined){
                                networkChartData[item.network_type] = 1
                            }else{
                                networkChartData[item.network_type] += 1
                            }
                        }
                        if(item.power_tag){
                            for(const x in item.power_tag){
                                if(sumPowerChart[x] == undefined){
                                    sumPowerChart[x] = new Array()
                                    sumPowerChart[x]['point'] = 0
                                    sumPowerChart[x]['point_total'] = 0
                                }
                                sumPowerChart[x]['point'] += item.power_tag[x]['point']
                                sumPowerChart[x]['point_total'] += item.power_tag[x]['point_total']
                            }
                        }
                        allusersPeerfeedback[item.email] = item.peerfeedback
                        for(const peerfeedback in item.peerfeedback){
                            if(excelsAtEachTypeSelected[peerfeedback] == undefined){
                                excelsAtEachTypeSelected[peerfeedback] = new Array()
                            }
                            excelsAtEachTypeSelected[peerfeedback].push({email: item.email, peerfeedback: item.peerfeedback[peerfeedback]})
                        }
                        for(const x in excelsAtEachTypeSelected){
                            excelsAtEachTypeSelected[x] = _.orderBy(excelsAtEachTypeSelected[x],['peerfeedback', 'email'], ['desc', 'asc'])
                        }
                    });
                    let sort_excelsAtDataChart = Object.keys(excelsAtEachTypeSelected).sort(function(a,b){return excelsAtEachTypeSelected[b].length - excelsAtEachTypeSelected[a].length})
                    let allMemberCount = response2.length
                    _.forEach(sort_excelsAtDataChart, (value,key)=> {
                        let datachart = {}
                        let viewList = {}
                        datachart['label'] = value
                        datachart['userCount'] = excelsAtEachTypeSelected[value].length
                        datachart['topUser'] = new Array()
                        _.forEach(excelsAtEachTypeSelected[value], (value,key)=> {
                            let obj = {}
                            let emailKey = value.email.replace(/\./g, "||");
                            let firstname = state.membersByKey[emailKey].firstname ? state.membersByKey[emailKey].firstname : ''
                            let lastname = state.membersByKey[emailKey].lastname ? state.membersByKey[emailKey].lastname : ''
                            let fullname = firstname +' '+ lastname
                            obj['fullname'] = fullname
                            obj['userId'] = emailKey
                            obj['imageProfile'] = state.membersByKey[emailKey].pic
                            obj['excelsCount'] = value.peerfeedback
                            datachart['topUser'].push(obj)
                        });
                        if(excelsAtDataChart.length == 0){
                            datachart['expand'] = true
                        }else{
                            datachart['expand'] = false
                        }
                        datachart['percentage'] = (datachart['userCount'] * 100) / allMemberCount
                        
                        viewList['label'] = value
                        viewList['userCount'] = excelsAtEachTypeSelected[value].length
                        viewList['userList'] = new Array()
                        _.forEach(excelsAtEachTypeSelected[value], (value,key)=> {
                            let obj = {}
                            let emailKey = value.email.replace(/\./g, "||");
                            let firstname = state.membersByKey[emailKey].firstname ? state.membersByKey[emailKey].firstname : ''
                            let lastname = state.membersByKey[emailKey].lastname ? state.membersByKey[emailKey].lastname : ''
                            let fullname = firstname +' '+ lastname
                            obj['fullname'] = fullname
                            obj['userId'] = emailKey
                            obj['imageProfile'] = state.membersByKey[emailKey].pic
                            obj['excelsCount'] = value.peerfeedback
                            obj['team_name'] = (state.membersByKey[emailKey].team && state.teamByKey[state.membersByKey[emailKey].team]) ? state.teamByKey[state.membersByKey[emailKey].team].name : ''
                            viewList['userList'].push(obj)
                        });
                        excelsAtDataChart.push(datachart)
                        viewListExcelsData[value] = viewList
                    });
                }
            }else{
                _.forEach(state.membersall, (item, key) => {
                    if(item.talent){
                        if(talentChartData[item.talent] == undefined){
                            talentChartData[item.talent] = 1
                        }else{
                            talentChartData[item.talent] += 1
                        }
                    }
                    if(item.network_type){
                        if(networkChartData[item.network_type] == undefined){
                            networkChartData[item.network_type] = 1
                        }else{
                            networkChartData[item.network_type] += 1
                        }
                    }
                    if(item.power_tag){
                        for(const x in item.power_tag){
                            if(sumPowerChart[x] == undefined){
                                sumPowerChart[x] = new Array()
                                sumPowerChart[x]['point'] = 0
                                sumPowerChart[x]['point_total'] = 0
                            }
                            sumPowerChart[x]['point'] += item.power_tag[x]['point']
                            sumPowerChart[x]['point_total'] += item.power_tag[x]['point_total']
                        }
                    }
                });
                excelsAtDataChart = state.excelsAtDataChartAll
                viewListExcelsData = state.viewListExcelsDataAll
            }
            _.forEach(powerChartData, (item, index) => {
                if(sumPowerChart[item.key]){
                    powerChartData[index]['point'] = sumPowerChart[item.key]['point']
                    powerChartData[index]['point_total'] = sumPowerChart[item.key]['point_total']
                }
            });
            // data.push(response1)
            data.push(response2)
            data.push(RiskAndStarChart)
            data.push(talentChartData)
            data.push(networkChartData)
            data.push(powerChartData)
            data.push(excelsAtDataChart)
            data.push(viewListExcelsData)
            return data
        },
        searchMembers({commit,dispatch}:any, checked:any){
            commit('setLoadingDataChart',true)
            commit('setRiskAndStarChart',{})
            commit('setPowerChartData',[])
            commit('setTalentChartData',{})
            commit('setNetworkChartData',{})
            commit('setExcelsAtDataChart',[])
            commit('setViewListExcelsData', [])
            dispatch('reponseSearchAll', {checked: checked}).then((result) => {
                // commit('setPeopleRisk', result[0])
                commit('setPeoplePerform',result[0])
                commit('setRiskAndStarChart',result[1])
                commit('setTalentChartData',result[2])
                commit('setNetworkChartData',result[3])
                commit('setPowerChartData',result[4])
                commit('setExcelsAtDataChart',result[5])
                commit('setViewListExcelsData', result[6])
                commit('setLoadingDataChart',false)
                
            });
        },
        searchByTeam({commit,dispatch}:any, checked:any){
            commit('setLoadingDataChart',true)
            commit('setRiskAndStarChart',{})
            commit('setPowerChartData',[])
            commit('setTalentChartData',{})
            commit('setNetworkChartData',{})
            commit('setExcelsAtDataChart',[])
            commit('setViewListExcelsData', [])
            dispatch('reponseSearchAll', {checked: checked}).then((result) => {
                // commit('setPeopleRisk', result[0])
                commit('setPeoplePerform',result[0])
                commit('setRiskAndStarChart',result[1])
                commit('setTalentChartData',result[2])
                commit('setNetworkChartData',result[3])
                commit('setPowerChartData',result[4])
                commit('setExcelsAtDataChart',result[5])
                commit('setViewListExcelsData', result[6])
                commit('setLoadingDataChart',false)
            });
        },
        searchByTalent({commit,dispatch}:any, checked:any){
            commit('setLoadingDataChart',true)
            commit('setRiskAndStarChart',{})
            commit('setPowerChartData',[])
            commit('setTalentChartData',{})
            commit('setNetworkChartData',{})
            commit('setExcelsAtDataChart',[])
            commit('setViewListExcelsData', [])
            dispatch('reponseSearchAll', {checked: checked}).then((result) => {
                // commit('setPeopleRisk', result[0])
                commit('setPeoplePerform',result[0])
                commit('setRiskAndStarChart',result[1])
                commit('setTalentChartData',result[2])
                commit('setNetworkChartData',result[3])
                commit('setPowerChartData',result[4])
                commit('setExcelsAtDataChart',result[5])
                commit('setViewListExcelsData', result[6])
                commit('setLoadingDataChart',false)
            });
        },
        // filterRisk({commit,state}:any,type:string){
        //     if(type == 'all'){
        //         state.peoplerisk = state.peopleriskall
        //     }else if(type == 'low'){
        //         state.peoplerisk = _.filter(state.peopleriskall, function(o:any) { return o.risk_level == '1'; })
        //     }else if(type == 'med'){
        //         state.peoplerisk = _.filter(state.peopleriskall, function(o:any) { return o.risk_level == '2'; })
        //     }else if(type == 'high'){
        //         state.peoplerisk = _.filter(state.peopleriskall, function(o:any) { return o.risk_level == '3'; })
        //     }
        // },
        sortBy({commit,state,dispatch}:any,objData:any){
            commit('setType',objData.type)
            commit('setPage',1)
            if(state.type == 'highest_risk'){
                state.sortorder = 'desc'
                state.sortfield = 'risk_level'
            }else if(state.type == 'lowest_risk'){
                state.sortorder = 'asc'
                state.sortfield = 'risk_level'
                
            }else if(state.type == 'highest_star'){
                state.sortorder = 'desc'
                state.sortfield = 'star'
            }else if(state.type == 'lowest_star'){
                state.sortorder = 'asc'
                state.sortfield = 'star'
            }else if(state.type == 'highest_impact'){
                state.sortorder = 'desc'
                state.sortfield = 'impact_rating'
            }else if(state.type == 'lowest_impact'){
                state.sortorder = 'asc'
                state.sortfield = 'impact_rating'
            }
            dispatch('reponseSearchAll', {checked: objData.checked}).then((result) => {
                // commit('setPeopleRisk', result[0])
                commit('setPeoplePerform',result[0])
            });
        },
        async getModalMemberData({commit,dispatch,state}:any, item:any){
            let arrData:Array<any> = [];
            let topskill:Array<any> = [];
            let peerfeedback = {}
            state.modalMemberData = []
            const typeMaster = (await firebase.database().ref('achievement_type').orderByChild("order_by").once('value')).val()
            await firebase.firestore().collection('users_achievements/').doc(item.email).get().then( async(doc)=> {
              if (doc.exists) {
                const _data:any = doc.data()
                  if(_data.peerfeedback) peerfeedback = _data.peerfeedback
                  if(_data.peerfeedback_unique){
                    for(const x in _data.peerfeedback_unique){
                        topskill.push({
                            key:x,
                            value:_data.peerfeedback_unique[x],
                        });
                    }
                    arrData['topskill'] = _.orderBy(topskill, ['value'],['desc'])
                  }
                  const arrAch:Array<any> = [];
                  const achievement_type:Array<any> = [];
                  arrData['achievements_total'] = 0
                  await firebase.firestore().collection('users_achievements/').doc(item.email).collection('achievements').get()
                  .then(async function (querySnapshot) {
                      querySnapshot.forEach(function (docAch) {
                        const _dataAch = docAch.data()
                        if(_dataAch.count1 == _dataAch.count1_total){
                          if (arrAch[_dataAch.type] === undefined) {
                            arrAch[_dataAch.type] = new Array();
                            arrAch[_dataAch.type].count = 0
                          }
                          if(_dataAch.count2){
                            if(_dataAch.count2 == _dataAch.count2_total){
                              arrAch[_dataAch.type].count += 1
                              arrData['achievements_total'] += 1
                            }
                          }else{
                            arrAch[_dataAch.type].count += 1
                            arrData['achievements_total'] += 1
                          }
                        }
                      });
                        if(peerfeedback){
                            let sort_peerfeedback = Object.keys(peerfeedback).sort(function(a,b){return peerfeedback[b] - peerfeedback[a]})
                            arrData['peerfeedback'] = new Object()
                            _.forEach(sort_peerfeedback, (value,key)=> {
                                arrData['peerfeedback'][value] = peerfeedback[value]
                            });
                        }
                        if(arrAch){
                            _.forEach(typeMaster, (value,key)=> {
                                let _data = value
                                if(_data.name && arrAch[_data.name]){
                                    _data.count = arrAch[value.name]['count']
                                }else{
                                    _data.count = 0
                                }
                                achievement_type.push(_data)
                            });
                            const achievement_type_order = _.orderBy(achievement_type, ['count'],['desc']);
                            arrData['achievements'] = achievement_type_order
                        }
                        await firebase.firestore().collection('here_point').where('send_to_email','==',item.email).where('hash','==',true).get()
                        .then(function (querySnapshot) {
                            const check:Array<any> = [];
                            const hashtagskey:Array<any> = [];
                            const hashtags:Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                for(const x in doc.data().hashtag){
                                    if(!check[doc.data().sender_email+'='+doc.data().hashtag[x]]){
                                        check[doc.data().sender_email+'='+doc.data().hashtag[x]] = true;
                                        if(!hashtagskey[doc.data().hashtag[x]]) hashtagskey[doc.data().hashtag[x]] = 0;
                                        hashtagskey[doc.data().hashtag[x]]++;
                                    }
                                }
                            });
                            for(const x in hashtagskey){
                                hashtags.push({
                                    key:x,
                                    value:hashtagskey[x],
                                });
                            }
                            arrData['cultureAdd'] = _.orderBy(hashtags, ['value'],['desc'])
                        });
                  });
              }
            });
            let relationships:any = {}
            const rel_maps = (await firebase.database().ref(`/rel_maps/${item.key}`).once('value')).val()
            const houseData:Array<any> = [];
            houseData['-LWOr-XsbZM2digYl1QL'] = new Array()
            houseData['-LWOr-XsbZM2digYl1QL']['color'] = '#1d97f2'
            houseData['-LWPrOElCYViBd6j6qP-'] = new Array()
            houseData['-LWPrOElCYViBd6j6qP-']['color'] = '#ffbf1f'
            houseData['-LWPrZbcyHAVHIFUsWLd'] = new Array()
            houseData['-LWPrZbcyHAVHIFUsWLd']['color'] = '#ea183c'
            relationships.center = item.email
            relationships.firstname = item.firstname
            relationships.lastname = item.lastname
            relationships.pic = item.pic
            relationships.house_color = (houseData[item.house] && houseData[item.house].color) ? houseData[item.house].color : ''
            relationships.dist_map = new Array()
            relationships.node_relations = new Array() 
            if(rel_maps && rel_maps.dists.length > 0){
              _.forEach(rel_maps.dists, (value,key)=> {
                let _item:any = value
                _item.distance = value.dist_norm
                _item.name = (value.team_name) ? value.team_name : ''
                _item.house_color = (value.house_id) ? houseData[value.house_id].color : ''
                _item.pic = value.pic;
                _item.firstname = value.firstname
                _item.lastname = value.lastname
                relationships.dist_map.push(_item)
              });
              _.forEach(rel_maps.edges, (value,key)=> {
                let _item:any = value
                relationships.node_relations.push(_item)
              });
            }
            arrData['relationships'] = relationships
            
            let arrBoss:Array<any> = [];
            let tempItem:any
            let sub =  _.filter(state.membersall, { 'boss': item.email })
            let _userData = state.membersByKey[item.key]
            if(_userData){
              _userData.direct_report = (sub.length > 0) ? sub.length : 0
              arrBoss.push(_userData)
            }
            
            if(item.boss && (state.membersByKey[item.boss.replace(/\./g, "||")] != undefined)){
              tempItem = item
            do{
              let keyIdBoss = tempItem.boss.replace(/\./g, "||")
              let subOfBoss =  _.filter(state.membersall, { 'boss': tempItem.boss })
              let u = state.membersByKey[keyIdBoss]
              if(u){
                u.direct_report = (subOfBoss.length > 0) ? subOfBoss.length : 0
                arrBoss.push(u)
              }
              if(u.boss){
                tempItem = u
              }else{
                tempItem = []
              }
            }
            while(tempItem.boss)
            }
            arrData['org'] = arrBoss.reverse()

            var axios = require('axios');
            var data = JSON.stringify({
            "company": item.company,
            "users": [
                item.email,
            ]
            });

            var config = {
                method: 'post',
                url: 'https://api-node.happily.ai/leaderboard/get',
                headers: { 
                    'Content-Type': 'application/json'
                },
                data : data
            };

            axios(config)
            .then(function (response) {
                const data = response.data
                if(data.data && data.data[item.email]){
                    arrData['leaderboard'] = _.orderBy(data.data[item.email], ['rank_all'],['asc'])
                }
                commit('setModalMemberData', arrData)
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        async getStarAndRiskDataChart({commit,dispatch,state,rootState}:any, user:any){
            // commit('setRiskAndStarChart',{})
            let dateNow = new Date()
            const startdate = format(addDays(dateNow,-60), "YYYY-MM")+'-01'
            const riskData: Array<any> = [];
            const starData: Array<any> = [];
            const impactData: Array<any> = [];
            let selectTeam:any
            if(!state.teamHeight){
                // if(user.user_type == 'leadership'){
                //     selectTeam = user.team
                //     commit('setTeamHeight', selectTeam)
                // }else{
                    if(rootState.team.teamsall.length >0){
                        let topmostArr: Array<any> = [];
                        _.forEach(rootState.team.teamsall, (value)=> {
                          if(value.parent == ''){
                            topmostArr.push(value.key)
                          }
                        });
                        selectTeam = topmostArr[0]
                        if(topmostArr.length > 1){
                            selectTeam = _.find(topmostArr, (value) => {
                            const chk_topmost = _.find(rootState.team.teamsall, { parent: value });
                            return !!chk_topmost;
                            });
                        }
                        commit('setTeamHeight', selectTeam)
                    }else{
                        let topmostArr: Array<any> = [];
                        let teamAll: Array<any> = [];
                        await firebase.database().ref('team').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
                            snapshot.forEach((doc): any => {
                                teamAll.push(doc.val())
                                if (!doc.val().parent){
                                    topmostArr.push(doc.key)
                                } 
                            });
                            selectTeam = topmostArr[0]
                            if(topmostArr.length > 1){
                                selectTeam = _.find(topmostArr, (value) => {
                                    const chk_topmost = _.find(teamAll, { parent: value });
                                    return !!chk_topmost;
                                });
                            }
                            commit('setTeamHeight', selectTeam)
                        });
                    }
                // }
            }
            let sat_of_lastweek = ''
            let sun_of_lastweek = ''
            if(state.masterDate.length == 0){
                const masterDate: Array<any> = [];
                const masterDateImpact: Array<any> = [];
                const labelDate: Array<any> = [];
                let lastdate:any = dateNow
                for(let i=7;i>=0;i--){
                    sat_of_lastweek = format(startOfWeek(lastdate,{weekStartsOn:-1}), 'YYYY-MM-DD')
                    sun_of_lastweek = format(startOfWeek(lastdate,{weekStartsOn:0}), 'YYYY-MM-DD')
                    lastdate = format(addDays(lastdate, -7), 'YYYY-MM-DD')
                    masterDate.push(sat_of_lastweek)
                    masterDateImpact.push(sun_of_lastweek)
                    let name = format(sat_of_lastweek, 'MMM').toUpperCase()
                    let day = format(sat_of_lastweek, 'D')
                    labelDate.push(name +' '+ day)
                }
                commit('setMasterDate',masterDate.reverse())
                commit('setMasterDateImpact',masterDateImpact.reverse())
                commit('setLabelDate',labelDate.reverse())
            }
            if(Object.keys(state.allDataRisk).length == 0 || Object.keys(state.allDataStar).length == 0 || Object.keys(state.allDataImpact).length == 0){
                const allUser =rootState.main.allUser// (await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
                var promise3 = new Promise(function(resolve, reject) {
                    const data3: Array<any> = [];
                    firebase.firestore().collection('report_weekly_risk_all').where('company','==',rootState.authen.user.company).where('date', '>=', `${startdate} 00:00:00`).orderBy('date').get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data()
                            const dateofweek = format(data.date, "YYYY-MM-DD")
                            if(data3[dateofweek] == undefined){
                                data3[dateofweek] = new Array()
                            }
                            if(data3[dateofweek][data.team] == undefined){
                                data3[dateofweek][data.team] = new Array()
                            }
                            data3[dateofweek][data.team].push(data)
                        });
                        resolve(data3);
                    });
                });
                // await firebase.firestore().collection('report_weekly_risk_all').where('company','==',rootState.authen.user.company).where('date', '>=', `${startdate} 00:00:00`).orderBy('date').get().then((querySnapshot)=>{
                //     querySnapshot.forEach((doc) => {
                //         const data = doc.data()
                //         const dateofweek = format(data.date, "YYYY-MM-DD")
                //         if(riskData[dateofweek] == undefined){
                //             riskData[dateofweek] = new Array()
                //         }
                //         if(riskData[dateofweek][data.team] == undefined){
                //             riskData[dateofweek][data.team] = new Array()
                //         }
                //         riskData[dateofweek][data.team].push(data)
                //     })
                //     commit('setAllDataRisk',riskData)
                // })
            // }
            // if(Object.keys(state.allDataStar).length == 0){
                var promise2 = new Promise(function(resolve, reject) {
                    const data2: Array<any> = [];
                    firebase.firestore().collection('report_weekly_performer_all').where('company','==',rootState.authen.user.company).where('date', '>=', `${startdate} 00:00:00`).orderBy('date').get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data()
                            const dateofweek = format(data.date, "YYYY-MM-DD")
                            if(data2[dateofweek] == undefined){
                                data2[dateofweek] = new Array()
                            }
                            if(data2[dateofweek][data.team] == undefined){
                                data2[dateofweek][data.team] = new Array()
                            }
                            data2[dateofweek][data.team].push(data)
                        });
                        resolve(data2);
                    });
                });
                // await firebase.firestore().collection('report_weekly_performer_all').where('company','==',rootState.authen.user.company).where('date', '>=', `${startdate} 00:00:00`).orderBy('date').get().then((querySnapshot)=>{
                //     querySnapshot.forEach((doc) => {
                //         const data = doc.data()
                //         const dateofweek = format(data.date, "YYYY-MM-DD")
                //         if(starData[dateofweek] == undefined){
                //             starData[dateofweek] = new Array()
                //         }
                //         if(starData[dateofweek][data.team] == undefined){
                //             starData[dateofweek][data.team] = new Array()
                //         }
                //         starData[dateofweek][data.team].push(data)
                //     })
                //     commit('setAllDataStar',starData)
                // })
            // }
            // if(Object.keys(state.allDataImpact).length == 0){
                var promise1 = new Promise(function(resolve, reject) {
                    const data1: Array<any> = [];
                    const dataImpactTooltip: Array<any> = [];
                    let lastindexDate = state.masterDateImpact.length - 1
                    if(new Date().getDay() == 0){
                        lastindexDate = lastindexDate - 1
                    }
                    firebase.firestore().collection('impact_rating').where('company','==',rootState.authen.user.company).where('date', '>=', `${startdate}`).orderBy('date').get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data()
                            const emailKey = data.email.replace(/\./g, '||')
                            if(allUser[emailKey]){
                                data.team = allUser[emailKey].team
                                const dateofweek = format(addDays(data.date, -1), 'YYYY-MM-DD')
                                if(data1[dateofweek] == undefined){
                                    data1[dateofweek] = new Array()
                                }
                                if(data1[dateofweek][data.team] == undefined){
                                    data1[dateofweek][data.team] = new Array()
                                }
                                data1[dateofweek][data.team].push(data)

                                if(data.date == state.masterDateImpact[lastindexDate]){
                                    let talentClass: any = 'a';
                                    let networkClass: any = 'a';
                                    let trulyClass: any = 'a';
                                    let starClass: any = 'a';
                                    let engagementClass: any = 'a'; 
                                    let powerSkillsClass: any = 'a'; 
                                    let valueAlignmentClass:any='a';
                                    

                             

                                    if(data.engagement_group == 'Inactive'){
                                        engagementClass='a'
                                    }else if(data.engagement_group == 'Somewhat Engaged'){
                                        engagementClass = 'b'
                                    }else if(data.engagement_group == 'Moderately Engaged'){
                                        engagementClass = 'c'
                                    }else if(data.engagement_group == 'Highly Engaged'){
                                        engagementClass = 'd'
                                    }else{
                                        engagementClass = 'a'
                                    }

                                    
            
                                    if(data.talent=='Marginalized'){
                                        talentClass='a'
                                    }else if(data.talent=='Up-and-coming'||
                                    data.talent=='Contributor'||
                                    data.talent=='Supported'||
                                    data.talent=='Rising Star'||
                                    data.talent=='Crowd Favorite'||
                                    data.talent=='Underutilized'||
                                    data.talent=='High Contributor'||
                                    data.talent=='Developing'||
                                    data.talent=='Hidden Talent'){
                                        talentClass='b'
                                    }
                                    else if(data.talent=='Activated'||
                                    data.talent=='Core Player'||
                                    data.talent=='High Potential'){
                                        talentClass='c'
                                    }
                                    else if(data.talent=='High Performer'||
                                    data.talent=='Solid Performer'||
                                    data.talent=='Superstar'){
                                        talentClass='d'
                                    }
                                    if(data.network_type=='Low Network'||
                                    data.network_type=='Medium Outer'||
                                    data.network_type=='Medium Inner'){
                                        networkClass='a'
                                    }else if(data.network_type=='Medium Network'||
                                    data.network_type=='High Outer'||
                                    data.network_type=='High Inner'){
                                        networkClass='b'
                                    }else if(data.network_type=='High Network'||
                                    data.network_type=='Super Outer'||
                                    data.network_type=='Super Inner'){
                                        networkClass='c'
                                    }else if(data.network_type=='Super Network'){
                                        networkClass='d'
                                    }
                                    // if(data.truely>=4){
                                    //     trulyClass='d'
                                    // }else if(data.truely>=2&&data.truely<=3){
                                    //     trulyClass='c'
                                    // }else if(data.truely==1){
                                    //     trulyClass='b'
                                    // }else if(data.truely<=0){
                                    //     trulyClass='a'
                                    // }




                                    if(data.medal_truely_value){
                                        if(data.medal_truely_value>=8){
                                            trulyClass='d'
                                        }else if(data.medal_truely_value>=7){
                                            trulyClass='c'
                                        }else if(data.medal_truely_value>=3.5){
                                            trulyClass='b'
                                        }else{
                                            trulyClass='a'
                                        }
                                    }
                        
                                  

                                    // Value Alignment =  sendcoins:t5, +  receivecoins:t6,
                                    const valueAlignment =( data.sendcoins? data.sendcoins:0) + (data.receivecoins?data.receivecoins:0)
                                    
                                    if(valueAlignment>=16){
                                        valueAlignmentClass='d'
                                    }else if(valueAlignment>=14){
                                        valueAlignmentClass='c'
                                    }else if(valueAlignment>=7){
                                        valueAlignmentClass='b'
                                    }else{
                                        valueAlignmentClass='a'
                                    }

                                    if(data.starperformer>=6){
                                        starClass='d'
                                    }else if(data.starperformer>=4&&data.starperformer<=5){
                                        starClass='c'
                                    }else if(data.starperformer>=1&&data.starperformer<=3){
                                        starClass='b'
                                    }else if(data.starperformer<=0){
                                        starClass='a'
                                    }

                                    //powerSkillsClass
                                    if(data.power_skill_rating>=8){
                                        powerSkillsClass='d'
                                    }else if(data.power_skill_rating>=6){
                                        powerSkillsClass='c'
                                    }else if(data.power_skill_rating>=3.5){
                                        powerSkillsClass='b'
                                    }else {
                                        powerSkillsClass='a'
                                    }

                                    
                                    
                                    dataImpactTooltip[data.email] = new Array()
                                    dataImpactTooltip[data.email].engagementClass = engagementClass
                                    dataImpactTooltip[data.email].talentClass = talentClass
                                    dataImpactTooltip[data.email].networkClass = networkClass
                                    dataImpactTooltip[data.email].trulyClass = trulyClass
                                    dataImpactTooltip[data.email].starClass = starClass
                                    dataImpactTooltip[data.email].powerSkillsClass=powerSkillsClass
                                    dataImpactTooltip[data.email].valueAlignmentClass=valueAlignmentClass
                                }
                            }
                        });
                        commit('setImpactTooltip',dataImpactTooltip)
                        resolve(data1);
                    });
                });
                // await firebase.firestore().collection('impact_rating').where('company','==',rootState.authen.user.company).where('date', '>=', `${startdate}`).orderBy('date').get().then((querySnapshot)=>{
                //     querySnapshot.forEach((doc) => {
                //         const data = doc.data()
                //         const emailKey = data.email.replace(/\./g, '||')
                //         if(state.membersByKey[emailKey]){
                //             data.team = state.membersByKey[emailKey].team
                //             const dateofweek = format(addDays(data.date, -1), 'YYYY-MM-DD')
                //             if(impactData[dateofweek] == undefined){
                //                 impactData[dateofweek] = new Array()
                //             }
                //             if(impactData[dateofweek][data.team] == undefined){
                //                 impactData[dateofweek][data.team] = new Array()
                //             }
                //             impactData[dateofweek][data.team].push(data)
                //         }
                //     })
                //     console.log(impactData)
                //     commit('setAllDataImpact',impactData)
                // })
            // }
                Promise.all([promise1, promise2, promise3]).then((values)=> {
                    const data1:any = values[0]
                    const data2:any = values[1]
                    const data3:any = values[2]
                    commit('setAllDataImpact',data1)
                    commit('setAllDataStar',data2)
                    commit('setAllDataRisk',data3)
                    commit('setLoadingDataChartFirstTime',false)
                });
            }
        },
        getRisk({commit,dispatch,state,rootState}:any, item:any){
            const riskData=[]
            firebase.firestore().collection('report_weekly_risk_area_all').where('email','==',item.email).get()
            .then((querySnapshot)=> {
                querySnapshot.forEach(async (doc)=> {
                  const data=doc.data()
                  let day=format(subDays(data.date,1),'YYYY-MM-DD')
                    if(!riskData[day]) riskData[day]=[]
                    riskData[day].push(data.category)
                });
                commit('setriskCategory',riskData)
              });
            let report_weekly_risk={}
            firebase.firestore().collection('report_weekly_risk_all').where('email','==',item.email).get().then((querySnapshot)=>{
                querySnapshot.forEach((doc) => {
                    const data=doc.data()
                    let day=format(subDays(data.date,1),'YYYY-MM-DD')
                    report_weekly_risk[day]=data
               
                })
                
                commit('setRisk',report_weekly_risk)
                
              })
        },
        getStarPerformer({commit,dispatch,state,rootState}:any, item:any){
            let report_weekly_performer={}
            firebase.firestore().collection('report_weekly_performer').where('email','==',item.email).get().then((querySnapshot)=>{
                querySnapshot.forEach((doc) => {
                    const data=doc.data()
                    let day=format(subDays(data.date,1),'YYYY-MM-DD')
                    report_weekly_performer[day]=data
                })
                commit('setStarPerformer',report_weekly_performer)
              })
        },
        getHoliday({commit,dispatch,state,rootState}:any, item:any){
            let holiday: Array<any> = [];
            firebase.firestore().collection('holliday').where('companyid','==',rootState.authen.user.company).get().then((querySnapshot)=>{
                querySnapshot.forEach((doc) => {
                    const data=doc.data()
                    holiday.push(data)
                })
                commit('setHoliday',holiday)
              })
        },
        async getDailyStatus({commit,dispatch,state,rootState}:any, item:any){
            commit('setLoadingLoadMoreData',true)
            let _data={}
            let currentDate=state.date
            let last30day=format(subDays(state.date,30),"YYYY-MM-DD")
            state.date=format(subDays(state.date,31),"YYYY-MM-DD")

            firebase.firestore().collection('users_questions').where("users","==",item.email).where('date',"<=",`${currentDate}`).where('date',">=",`${last30day}`).get().then((querySnapshot)=>{
                querySnapshot.forEach((doc) => {
                    const data=doc.data()
                    if(data.quest_id=="-Kgs61AHOnpJ3rfyQr6t"){
                        if(_data[data.date]){
                            _data[data.date]=""
                          }
                            if(data.answer==0||data.answer==1){
                                _data[data.date]="green"
                              }else if(data.answer==2){
                                _data[data.date]="yellow"
                              }else if(data.answer==3||data.answer==4){
                                _data[data.date]="red"
                              }
                              else{
                                _data[data.date]="gray"
                              }
                        
                    }
                })
            for(var i=30;i>=0;i--){
                let temp_data={}
                const date=format(subDays(currentDate,i),"YYYY-MM-DD")
                const daytext=format(new Date(date), "ddd");
                var _holiday = _.find(state.holiday, function(value){
                    return value != null && value.date == date;
                  });
                var starPerformer=state.starPerformer[date]?"S":""
                var risk=state.risk[date]?state.risk[date].risk_level+"R":""
                let risk_due_txt = state.risk[date]?state.risk[date].risk_due:"Happiness"
                let riskCategoryTxt=""
                if(state.riskCategory[date]){
                  let conut=0
                  for(var j in state.riskCategory[date]){
                    conut+=1
                    if(state.riskCategory[date].length==conut){
                      riskCategoryTxt=riskCategoryTxt+state.riskCategory[date][j]
                    }else{
                      riskCategoryTxt=riskCategoryTxt+state.riskCategory[date][j]+", "
                    }
                    
                  }
                }


                var highlight:any=false
                var highlight_txt:any=false
                if(starPerformer&&risk)
                {
                    highlight=starPerformer+"&"+(risk=="1R"?"R":risk)
                    riskCategoryTxt=riskCategoryTxt?riskCategoryTxt:'Happiness'
                    highlight_txt= `Star Performer<br><br>${risk_due_txt}`
                    // if(highlight=="S&3R"){
                    //     highlight_txt= `Star Performer with Problem Areas: Wellness, Personal Growth`
                    // }else if(highlight=="S&2R"){
                    //     highlight_txt= `Star Performer with Problem Areas: Wellness, Personal Growth`
                    // }else if(highlight=="S&R"){
                    //     highlight_txt= `Star Performer with Problem Areas: Wellness, Personal Growth`
                    // }
                }else if(starPerformer){
                    highlight=starPerformer
                    highlight_txt=`Star Performer`
                }else if(risk){
                    highlight=risk=="1R"?"R":risk
                    riskCategoryTxt=riskCategoryTxt?riskCategoryTxt:'Happiness'
                    highlight_txt= `${risk_due_txt}`
                   
                }
               
                

                  if(!_holiday){
                    
                    temp_data={
                        day: daytext,
                        date: date,
                        status: daytext=="Sun"||daytext=="Sat"?"none":_data[date],
                        highlight: highlight,
                        highlightContent: highlight_txt,
                      }
                  }else{
                    temp_data={
                        day: daytext,
                        date: date,
                        status: daytext=="Sun"||daytext=="Sat"?"none":"holiday",
                        highlight: highlight,
                        highlightContent: highlight_txt,
                      }
                  }
                  state.riskData.push(temp_data)
                  state.riskData=_.sortBy(state.riskData, [
                    function (o) {
                      return new Date(o.date);
                    },
                  ]);
                 }
            })
            commit('setLoadingLoadMoreData',false)
        },
        async getPowerData({commit,dispatch,state,rootState}:any, item:any){
        commit('setPowerData',[])
        let power: Array<any> = [];
        if(item.email){
            const emailKey = item.email.replace(/\./g, '||')
            var userData =rootState.main.allUser[emailKey]// (await firebase.database().ref(`/users/${emailKey}`).once('value')).val()
        }
        power.push(
            {
                label: "Empathy",
                rating: userData.power_tag12?(userData.power_tag12.ps_empathy && userData.power_tag12.ps_empathy.rating > 0 && userData.power_tag12.ps_empathy.answer > 0 ?(userData.power_tag12.ps_empathy.rating / userData.power_tag12.ps_empathy.answer).toFixed(1):'—'):'—',
                value: userData.power_tag?(userData.power_tag.ps_empathy?userData.power_tag.ps_empathy.point:0):0,
                maxValue: userData.power_tag?(userData.power_tag.ps_empathy?userData.power_tag.ps_empathy.point_total:0):0,
                icon: "ic_empathy",
                percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_empathy?userData.power_tag12.ps_empathy.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_empathy?userData.power_tag12.ps_empathy.point_total:0):0)),
              },
              {
                label: "Self-awareness",
                rating: userData.power_tag12?(userData.power_tag12.ps_self_awareness && userData.power_tag12.ps_self_awareness.rating > 0 && userData.power_tag12.ps_self_awareness.answer > 0 ?(userData.power_tag12.ps_self_awareness.rating / userData.power_tag12.ps_self_awareness.answer).toFixed(1):'—'):'—',
                value: userData.power_tag?(userData.power_tag.ps_self_awareness?userData.power_tag.ps_self_awareness.point:0):0,
                maxValue: userData.power_tag?(userData.power_tag.ps_self_awareness?userData.power_tag.ps_self_awareness.point_total:0):0,
                icon: "ic_selfawareness",
                percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_self_awareness?userData.power_tag12.ps_self_awareness.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_self_awareness?userData.power_tag12.ps_self_awareness.point_total:0):0)),
              },
              {
                label: "Critical Thinking",
                rating: userData.power_tag12?(userData.power_tag12.ps_critical_thinking && userData.power_tag12.ps_critical_thinking.rating > 0 && userData.power_tag12.ps_critical_thinking.answer > 0 ?(userData.power_tag12.ps_critical_thinking.rating / userData.power_tag12.ps_critical_thinking.answer).toFixed(1):'—'):'—',
                value:userData.power_tag?(userData.power_tag.ps_critical_thinking?userData.power_tag.ps_critical_thinking.point:0):0,
                maxValue:userData.power_tag?(userData.power_tag.ps_critical_thinking?userData.power_tag.ps_critical_thinking.point_total:0):0,
                icon: "ic_criticalthinking",
                percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_critical_thinking?userData.power_tag12.ps_critical_thinking.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_critical_thinking?userData.power_tag12.ps_critical_thinking.point_total:0):0)),
              },
              {
                label: "Leadership",
                rating: userData.power_tag12?(userData.power_tag12.ps_leadership && userData.power_tag12.ps_leadership.rating > 0 && userData.power_tag12.ps_leadership.answer > 0 ?(userData.power_tag12.ps_leadership.rating / userData.power_tag12.ps_leadership.answer).toFixed(1):'—'):'—',
                value: userData.power_tag?(userData.power_tag.ps_leadership?userData.power_tag.ps_leadership.point:0):0,
                maxValue: userData.power_tag?(userData.power_tag.ps_leadership?userData.power_tag.ps_leadership.point_total:0):0,
                icon: "ic_leadership",
                percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_leadership?userData.power_tag12.ps_leadership.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_leadership?userData.power_tag12.ps_leadership.point_total:0):0)),
              },
              {
                label: "Initiative-making",
                rating: userData.power_tag12?(userData.power_tag12.ps_initiative_making && userData.power_tag12.ps_initiative_making.rating > 0 && userData.power_tag12.ps_initiative_making.answer > 0 ?(userData.power_tag12.ps_initiative_making.rating / userData.power_tag12.ps_initiative_making.answer).toFixed(1):'—'):'—',
                value: userData.power_tag?(userData.power_tag.ps_initiative_making?userData.power_tag.ps_initiative_making.point:0):0,
                maxValue:userData.power_tag?(userData.power_tag.ps_initiative_making?userData.power_tag.ps_initiative_making.point_total:0):0,
                icon: "ic_initiative",
                percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_initiative_making?userData.power_tag12.ps_initiative_making.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_initiative_making?userData.power_tag12.ps_initiative_making.point_total:0):0)),
              },
              {
                label: "Optimism",
                rating: userData.power_tag12?(userData.power_tag12.ps_optimism && userData.power_tag12.ps_optimism.rating > 0 && userData.power_tag12.ps_optimism.answer > 0 ?(userData.power_tag12.ps_optimism.rating / userData.power_tag12.ps_optimism.answer).toFixed(1):'—'):'—',
                value: userData.power_tag?(userData.power_tag.ps_optimism?userData.power_tag.ps_optimism.point:0):0,
                maxValue:userData.power_tag?( userData.power_tag.ps_optimism?userData.power_tag.ps_optimism.point_total:0):0,
                icon: "ic_optimism",
                percent:isNaN(((userData.power_tag12?(userData.power_tag12.ps_optimism?userData.power_tag12.ps_optimism.point:0):0)*100)/(userData.power_tag12?(userData.power_tag12.ps_optimism?(userData.power_tag12.ps_optimism.point_total?userData.power_tag12.ps_optimism.point_total:0):0):0)),
              },
        )
        power.map(value=>{
            if(value.percent==true){
                value.percent=0
            }
        })

        var data = _.orderBy(power, ['percent','value'], ['desc', 'desc']);
        commit('setPowerData',data)
        
        },
        clearDate({commit,dispatch,state,rootState}:any, item:any){
            state.date=format(new Date(),"YYYY-MM-DD"),
            state.riskData=[]
        },
        async getAlignement({commit,dispatch,state,rootState}:any, item:any){
            let alignementData = {}
            let recognition = {}
            const truly={}

            const past60day=format(subDays(new Date(),60),"YYYY-MM-DD")
            let enddate = format(new Date(), 'YYYY-MM-DD')
            console.log("past60day",past60day)
            firebase.firestore().collection('peerfeedback').where("company", "==", rootState.authen.user.company).where('date','>=',past60day).get()
            .then((querySnapshot)=> {
                querySnapshot.forEach(async (doc)=> {
                    const data = doc.data()
                    if(data.suggest.line1_en === 'Truly' ||data.suggest.line1_en === 'Exceeding'){
                        truly[data.email_to] = (truly[data.email_to])?truly[data.email_to]+1:1;
                    }
                    
                })
                
                commit("setTruly",truly)
            })
            firebase.firestore().collection('here_point').where("company", "==", rootState.authen.user.company).where('statusrow','in',['sendcoin','sendgem']).where('date', '>=', past60day).where('date', '<=', enddate).get()
            .then((querySnapshot)=> {
                querySnapshot.forEach(async (doc)=> {
                    const u = doc.data()
                    
                    let rating = 0;
                    let _rating = 0;
                    if(u.statusrow == 'sendcoin'){
                        if(!recognition[u.sender_email]){
                        recognition[u.sender_email]={effortGiven:0,totalGiven:0,effortReceived:0,totalReceived:0,alignmentRatio:0}
                        }
                        if(!recognition[u.send_to_email]){
                            recognition[u.send_to_email]={effortGiven:0,totalGiven:0,effortReceived:0,totalReceived:0,alignmentRatio:0}
                            }
                        for(const i in u.core_value_ai){
                            if(u.core_value_ai[i].rating){
                               
                                //emailKey=u.sender_email.replace(/\./g, '||')
                               
                                    if(_rating < parseFloat(u.core_value_ai[i].rating)){
                                        _rating = parseFloat(u.core_value_ai[i].rating);
                                    }
                                    
                                

                                
                                    if(rating < parseFloat(u.core_value_ai[i].rating)){
                                        rating = parseFloat(u.core_value_ai[i].rating);
                                    }
                                    
                            }
                         
                        }
                     
                            recognition[u.sender_email].effortGiven=recognition[u.sender_email].effortGiven+_rating
                            recognition[u.sender_email].totalGiven++
                            recognition[u.send_to_email].effortReceived=recognition[u.send_to_email].effortReceived+rating
                            recognition[u.send_to_email].totalReceived++
                        
                    }
                })
                for(const key in recognition){
                    recognition[key].valueAlignmentGiven= isNaN((recognition[key].effortGiven)/(recognition[key].totalGiven))?0:((recognition[key].effortGiven)/(recognition[key].totalGiven)).toFixed(1)
                    recognition[key].valueAlignmentReceived= isNaN((recognition[key].effortReceived)/(recognition[key].totalReceived))?0:((recognition[key].effortReceived)/(recognition[key].totalReceived)).toFixed(1)
                    recognition[key].combinedValueAlignment= isNaN((recognition[key].effortGiven+recognition[key].effortReceived)/(recognition[key].totalGiven+recognition[key].totalReceived))?0:((recognition[key].effortGiven+recognition[key].effortReceived)/(recognition[key].totalGiven+recognition[key].totalReceived)).toFixed(1)
                    recognition[key].combinedValueAlignment_circle=recognition[key].combinedValueAlignment*10
                }
                //console.log("recognition",recognition)
               commit("setRecognition",recognition)
               
            })
            await firebase.firestore().collection('users_questions').where('company','==',rootState.authen.user.company).where('date','>=',past60day).where('type','==','Text Area Field').where('status','==','close').get().then( async snapshot => {
                snapshot.forEach((doc)=>{
                    if(doc.data().power_skill_rating && doc.data().power_tag){
                        if(!alignementData[doc.data().users]){
                            alignementData[doc.data().users]={rating:0,total:0,rating_skill:0}
                        }
                        if (typeof doc.data().power_skill_rating === 'number') {
                            alignementData[doc.data().users].rating+= doc.data().power_skill_rating;
                            alignementData[doc.data().users].total++;
                        }else if(typeof alignementData === 'object' && doc.data().power_skill_rating['rating']){
                            alignementData[doc.data().users].rating+= Number(doc.data().power_skill_rating['rating']);
                            alignementData[doc.data().users].total++;
                        }
                    }
                });
                for(let key in alignementData){
                    alignementData[key].rating_skill = isNaN(alignementData[key].rating / alignementData[key].total) ? 0 : (alignementData[key].rating / alignementData[key].total).toFixed(1)
                }
                //console.log("alignementData",alignementData)
                commit("setAlignement",alignementData)
            });
            const medals = {}
            await firebase.firestore().collection('here_point').//orderBy("medal", "asc").get().then( async query => {
            where('company','==',rootState.authen.user.company).where('date','>=',past60day).where('type','==','powerup').get().then( async query => {
                const data = [];
                query.forEach( async (doc) => {
                  
                    if(doc.data().medal) {
                        // console.log("doc.data()",doc.data().date)
                        // console.log("doc.data()",doc.data())
                        data[doc.id] = doc.data();
                    
                        //if(data[doc.id].medal){
                            if(data[doc.id].send_to_email === 'Everyone' && data[doc.id].type2 === 'medal'){
                                // for(const user in users){
                                //     medals[user] = (medals[user])?medals[user]+1:1;
                                // }
                            }else if(data[doc.id].type2 === 'medal' && data[doc.id].profileimage && data[doc.id].profileimage.length < 3){
                                for(const user in data[doc.id].profileimage){
                                    if(data[doc.id].profileimage.hasOwnProperty(user)){
                                        const emailKey = data[doc.id].profileimage[user].email//.replace(/\./g, '||');
                                        medals[emailKey] = (medals[emailKey])?medals[emailKey]+1:1;
                                    }
                                }
                            }else if(data[doc.id].type2 === 'medal' && data[doc.id].profileimage && data[doc.id].profileimage.length >= 3){
                                await firebase.firestore().collection(`here_point/${doc.id}/here_point_members`).get().then( async query => {
                                    query.forEach((doc) => {
                                        const emailKey = doc.data().email//.replace(/\./g, '||');
                                        medals[emailKey] = (medals[emailKey])?medals[emailKey]+1:1;
                                    });
                                });
                            }else if(!data[doc.id].type2){
                                const emailKey = data[doc.id].send_to_email//.replace(/\./g, '||');
                                medals[emailKey] = (medals[emailKey])?medals[emailKey]+1:1;
                            }
                        }
                    
                });
                commit("setMedals",medals)
                //console.log("medals",medals)
            });

        }
    },
    getters: {
        // peoplerisk: (state:any) => {
        //     return state.peoplerisk
        // },
        starperform: (state:any) => {
            return state.starperform
        },
        inputSearch: (state:any) => {
            return state.inputSearch
        },
        selectTeam: (state:any) => {
            return state.team_id
        },
        loadpage: (state:any) => {
            return state.loadpage
        },
        talentTypeOption: (state:any) => {
            return state.talentTypeOption
        },
        modalMemberData : (state:any) => {
            return state.modalMemberData
        },
        membersall : (state:any) => {
            return state.membersall
        },
        riskData : (state:any) => {
            return state.riskData
        },
        loadingLoadMoreData: (state:any) => {
            return state.loadingLoadMoreData
        },
        powerData: (state:any) => {
            return state.powerData
        },
        RiskAndStarChart: (state:any) => {
            return state.RiskAndStarChart
        },
        labelDate: (state:any) => {
            return state.labelDate
        },
        talentChartData: (state:any) => {
            return state.talentChartData
        },
        networkChartData: (state:any) => {
            return state.networkChartData
        },
        powerChartData: (state:any) => {
            return state.powerChartData
        },
        excelsAtDataChart: (state:any) => {
            return state.excelsAtDataChart
        },
        viewListExcelsData: (state:any) => {
            return state.viewListExcelsData
        },
        loadingDataChartFirstTime: (state:any) => {
            return state.loadingDataChartFirstTime
        },
        loadingDataChart: (state:any) => {
            return state.loadingDataChart
        },
        allDataImpactTooltip: (state:any) => {
            return state.allDataImpactTooltip
        },
        alignement: (state:any) => {
            return state.alignement
        },
        recognition: (state:any) => {
            return state.recognition
        },
        truly: (state:any) => {
            return state.truly
        },
        medals: (state:any) => {
            return state.medals
        }
    }
  }
